export default {"src":"/_next/static/media/error-circle.17416c53.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};